// get partners list
export const GET_PARTNERS_LIST = "GET_PARTNERS_LIST";
export const GET_PARTNERS_LIST_SUCCESS = "GET_PARTNERS_LIST_SUCCESS";
export const GET_PARTNERS_LIST_FAILURE = "GET_PARTNERS_LIST_FAILURE";
